<template>
  <div id="content" v-show="!loading">
    <popup v-show="hasPopup"
           :popup-type="getPopupType"
           :popup-action="getPopupAction"
           @popup-action="executePopupAction"></popup>
    <service-replace-channel-popup
      v-if="replaceData"
      :popup-data="replaceData"
      @replace="replaceChannels"
      @close-popup="closePopup"
    />
    <business-models-modal ref="businessmodelsmodalref" />
    <form>
      <div class="inner">
        <p class="paging">
          <router-link :to="{ name: moduleName }" class="btn btn_back" v-translate>Seznam</router-link>
        </p>
        <p class="buttons">
              <a v-if="!entity.enabled && !disabled"
                 class="btn btn_action btn_grey btn_enable"
                 :title="'Aktivovat' | translate"
                 @click.prevent.stop="updateEntityActive('active', true)"
                 v-translate>Aktivovat</a>
              <a v-if="entity.enabled && !disabled"
                 class="btn btn_action btn_grey btn_disable"
                 :title="'Deaktivovat' | translate"
                 @click.prevent.stop="updateEntityActive('active', false)"
                 v-translate>Deaktivovat</a>
              <a v-if="$_deleteActionAllowed && !disabled"
                 class="btn btn_action btn_delete"
                 :title="'Smazat' | translate"
                 @click.prevent.stop="deleteEntity"
                 v-translate>Smazat</a>
        </p>
        <h1>{{entity.name}}</h1>
      </div>
      <div class="responsiveTabs">
        <div class="tabs_content">
          <section v-show="$_readActionAllowedAll">
            <div class="left">
              <h2 v-translate>Výběr operátora</h2>
            </div>
            <div class="right">
              <div class="field_left">
                <operator-select
                    v-model="operatorIdComputed"
                    :options="operatorOptions"
                    :disabled="true"
                >
                </operator-select>
              </div>
              <div class="field_right">
                <select-box
                    v-if="!isGlobalPackage || !$_loggedUser_action_allowed('businessModels')"
                    id="packagebusinessmodel"
                    :options="allBusinessModelsWithUndefinedOption"
                    v-model="businessModelSingle"
                    :required="true"
                    :disabled="true"
                    ref="packagebusinessmodelref"
                >
                  <translate class="translate">Business model</translate>
                </select-box>
                <select-box-multi
                    v-if="isGlobalPackage && $_loggedUser_action_allowed('businessModels')"
                    id="packagebusinessmodel"
                    :options="multiBusinessModelOptions"
                    v-model="entity.id_business_models"
                    :required="true"
                    :disabled="!$_updateActionAllowed"
                    ref="packagebusinessmodelref"
                >
                  <translate class="translate">Business model</translate>
                </select-box-multi>
              </div>
            </div>
          </section>
          <section>
            <div class="left">
              <detail-entity-info
                  :entity="entity"
              >
              </detail-entity-info>
            </div>

            <div class="right">
              <div class="field_left">
                <text-input id="package-name"
                            v-model="entity.name"
                            :required="true"
                            :disabled="disabled"
                            ref="packagenameref"
                >
                  <translate class="translate">Název balíčku</translate>
                </text-input>
              </div>
              <div class="field_right">
                <text-input id="package-price"
                            v-model="entity.price"
                            :disabled="disabled"
                >
                  <translate class="translate">Cena (Kč)</translate>
                </text-input>
              </div>
              <div class="field_left">
                <select-box
                    id="package_type"
                    :required="true"
                    :disabled="disabled"
                    v-model="packageTypeComputed"
                    :options="packageTypeOptions"
                    ref="packagetyperef"
                >
                  <translate class="translate">Typ balíčku</translate>
                </select-box>
              </div>
              <div class="field_right checkboxes" v-show="entity.type === 'basic'">
                <filter-checkbox
                    id="combinationwithbasic"
                    name="combinationwithbasic"
                    :disabled=disabled
                    :val="entity.combination_with_basic"
                    v-model="entity.combination_with_basic"
                >
                  <translate class="translate">Kombinace se základními balíčky</translate>
                </filter-checkbox>
                <filter-checkbox
                    id="combinationwiththematic"
                    name="combinationwiththematic"
                    :disabled=disabled
                    :val="entity.combination_with_thematic"
                    v-model="entity.combination_with_thematic"
                >
                  <translate class="translate">Kombinace s tématickými balíčky</translate>
                </filter-checkbox>
              </div>
              <div class="field_left">
                <filter-checkbox
                    id="includeinreport"
                    name="includeinreport"
                    :val="entity.include_in_report"
                    v-model="entity.include_in_report"
                    :disabled="disabled"
                ><translate class="translate">Zahrnovat do reportingu</translate>
                </filter-checkbox>
              </div>
            </div>
          </section>
            <channel-checkbox-list-section
                v-if="!loading"
                :editable="!disabled"
                :title="'Kanály' | translate"
                :show-channel-sort="true"
                group-id="channels"
                :items="allChannels"
                :selected-items="entity.id_channels"
                @toggle-select="entity.id_channels = arguments[0]"
                :showReplace="true"
                @onReplaceClick="initReplaceChannelPopup"
                @show-business-models="$refs.businessmodelsmodalref.showBusinessModels(arguments[0])"
            ></channel-checkbox-list-section>
        </div>
        <detail-bottom-buttons
            v-if=!disabled
            section-class="buttons"
            :show-link="true"
            :module-name="moduleName"
            @submit-form="submitForm"
        ></detail-bottom-buttons>
      </div>
    </form>
  </div>
</template>

<script>
import ChannelCheckboxListSection from "@/components/common/ChannelCheckboxListSection"

import detailActions from "@/components/mixins/detail-actions"
import packages from "@/components/views/packages/mixins/packages"
import requiredFields from "@/components/mixins/required-fields"
import FilterCheckbox from "@/components/common/FilterCheckbox"
import SelectBoxMulti from "@/components/common/SelectBoxMulti"
import ServiceReplaceChannelPopup from "@/components/common/ServiceReplaceChannelPopup"
import BusinessModelsModal from "../../common/BusinessModelsModal.vue";

export default {
  name: "PackageDetail",
  components: {
    BusinessModelsModal,
    SelectBoxMulti,
    FilterCheckbox,
    ChannelCheckboxListSection,
    ServiceReplaceChannelPopup
  },
  mixins: [detailActions, requiredFields, packages],
  created: function (PackageService, OperatorService, BusinessModelService) {
    this.entityService = PackageService

    this.createdInit()
        .then(() => {
          this.operatorService = OperatorService
          if (this.$_readActionAllowedAll) {
            this.businessModelService = BusinessModelService
            this.getOperatorsAndBusinessModels(true)
                .then(() => {
                  this.setBusinessModelByOperatorId(this.entity.id_operator, true)
                });
          }else if(this.$_readActionAllowed && this.entity.id_operator == this.$_loggedUser_operatorId) {
            this.canEdit = this.$_loggedUser_canModifyOwnChannelPackages;
          }
        })
  },
  data(){
    return {
      canEdit: true,
      replaceData: null,
    }
  },
  computed: {
    isActive() {
      return this.entity.enabled
    },
    isGlobal() {
      return this.entity.global
    },
    disabled(){
      return !this.$_updateActionAllowed || !this.canEdit;
    }
  },
  methods: {
    submitForm(redirect = false) {
      this.updateEntity(this.entity, redirect)
    },
    getEntity() {
      this.setLoadingMessage()
      return this.entityService.getEntity(this.$route.params.id, {id_selected_operator: this.$_loggedUser_selectedOperatorId})
          .then(data => {
            this.allChannels = data['all_channels']
            this.entity = data['channel_package']
            this.isPackageInAnyService = data['is_package_in_any_service']
            this.emptyMessage()
          })
    },
    getChannelData(channelId) {
      return this._.find(this.allChannels, function (item) {
        return item.id === channelId
      })
    },
    initReplaceChannelPopup(id, channelType) {
      const allChannels = this.allChannels.map(c => ({...c, id: parseInt(c.id.replace(/[^0-9]*/, ''))}))
      const selectedChannels = this.entity.id_channels.map(c => parseInt(c))

      let channelData = this.getChannelData(id)
      this.replaceData = {
        'id': channelData.id.replace(/[^0-9]*/, ''),
        'name': channelData.name,
        'channels': allChannels.filter(c => !selectedChannels.includes(c.id)),
        'channelType': channelType,
      }
    },
    closePopup() {
      this.replaceData = null
    },
    replaceChannels(data) {
      this.replaceData = null
      this.entityService.replaceChannels(this.entity.id, data)
          .then(() => {
            this.setSuccessMessage()
            this.getEntity()
          })
          .catch(function (error) {
            this.setErrorMessage(this._processDetailErrorMessage(error))
          }.bind(this))
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/packages/PackageDetail.vue